import { Skeleton } from '@/ui/components/common/Skeleton'

/**
 * Three stacked skeleton bars shown while the recent investigations list
 * is loading.
 */
export function ListSkeleton() {
  return (
    <div className="space-y-3">
      <Skeleton className="h-10 w-full" />
      <Skeleton className="h-10 w-full" />
      <Skeleton className="h-10 w-full" />
    </div>
  )
}
